import { SafeStorage } from '../../utils/jsbridge';

const accId = window.__baseInfo.accId;
const getCurrentShop = async () => {
    let currentShop = await SafeStorage.getItem('currentShop');
    currentShop = currentShop ? JSON.parse(currentShop) : null;
    return currentShop ? currentShop[accId] : null;
}

export default getCurrentShop;

export const getCurrentShopId = async () => {
    const currentShop = await getCurrentShop();
    const shopId = currentShop ? currentShop.shopId : null;
    return shopId;
}